import { v4 as uuid4 } from 'uuid';

export const BASIC_INPUT_DEFAULT_VALUE = null;

export const DATE_INPUT_DEFAULT_VALUE = new Date().toISOString();

export const PERSON_DEFAULT_VALUE = [
  {
    id: uuid4(),
    firstName: null,
    middleName: null,
    lastName: null,
  },
];

export const AFFILIATIONS_DEFAULT_VALUE = [
  {
    id: uuid4(),
    departmentName: null,
    universityName: null,
    city: null,
    state: null,
    country: null,
    zip: null,
    authors: [false],
    isEmpty: true,
  },
];

export const BASICARRAYINPUT_DEFAULT_VALUE = [
  {
    uniqueID: uuid4(),
    value: null,
  },
];

export const REFERENCES_DEFAULT_VALUE = [
  {
    value: null,
    uniqueID: uuid4(),
    notCited: '1',
    checkedToExport: false,
    citationValue: null,
    cslJSON: null,
  },
];

export const SLATE_DEFAULT_VALUE = {
  document: {
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        nodes: [
          {
            object: 'text',
            leaves: [
              {
                text: '',
              },
            ],
          },
        ],
      },
    ],
  },
};

export const USER_PREFERENCES = {
  layout: {
    refPad: false,
    previewPad: false,
    leftPane: true,
    menuBar: true,
  },
};
